export default __webpack_public_path__ + "static/media/filmage-home-large.859d76ee.jpg";